export const SIDEBAR_ACTIONS = {
  OPEN_SIDEBAR: 'OPEN_SIDEBAR',
  CLOSE_SIDEBAR: 'CLOSE_SIDEBAR'
};

export const TAGS_ACTIONS = {
  SET_ALL_TAGS: 'SET_ALL_TAGS',
  SET_DEFAULT_CREATE_TAG_INPUTS: 'SET_DEFAULT_CREATE_TAG_INPUTS',
  SET_DEFAULT_EDIT_TAG_INPUTS: 'SET_DEFAULT_EDIT_TAG_INPUTS',
  ADD_NEW_TAG: 'ADD_NEW_TAG',
  UPDATE_TAG: 'UPDATE_TAG'
};

export const MESSAGE_DETAIL_ACTIONS = {
  PROCESS_MESSAGE_REQUEST: 'PROCESS_MESSAGE_REQUEST',
  PROCESS_MESSAGE_SUCCESS: 'PROCESS_MESSAGE_SUCCESS',
  PROCESS_MESSAGE_FAILURE: 'PROCESS_MESSAGE_FAILURE'
};

export const CREATE_CAMPAIGN_ACTIONS = {
  SET_ALL_QR_CATALOGS: 'SET_ALL_QR_CATALOGS',
  SET_ALL_GUPSHUP_CATALOGS: 'SET_ALL_GUPSHUP_CATALOGS',
  ADD_NEW_CAMPAIGN: 'ADD_NEW_CAMPAIGN'
};

export const CUSTOMER_ACTIONS = {
  SET_CUSTOMER_INFO: 'SET_CUSTOMER_INFO',
  SET_ACTIVE_TAB: 'SET_ACTIVE_TAB'
};

export const WS_CALL_SIDEBAR_ACTIONS = {
  SET_CLIENTS: 'SET_CLIENTS',
  SET_LOADING: 'SET_LOADING',
  SET_SEARCH_TEXT: 'SET_SEARCH_TEXT',
  SET_CURRENT_STEP: 'SET_CURRENT_STEP',
  SET_SELECTED_CLIENT: 'SET_SELECTED_CLIENT',
  SET_FETCH_ERROR: 'SET_FETCH_ERROR',
  RESET_STATE: 'RESET_STATE'
};
export const TEAMS_ACTIONS = {
  TEAMS_LOADING_START: 'TEAMS_LOADING_START',
  TEAMS_LOADING_ERROR: 'TEAMS_LOADING_ERROR',
  SET_ALL_TEAMS: 'SET_ALL_TEAMS',
  TEAMS_ALREADY_LOADED: 'TEAMS_ALREADY_LOADED'
};

export const INBOX_RIGHT_ACTIONS = {
  SET_CUSTOMER_DATA: 'SET_CUSTOMER_DATA',
  UPDATE_CUSTOMER_DATA: 'UPDATE_CUSTOMER_DATA',
  SET_CUSTOMER_LOADING: 'SET_CUSTOMER_LOADING',
  SET_CUSTOMER_ERROR: 'SET_CUSTOMER_ERROR',
  SET_CUSTOMER_DETAILS_EDITING: 'SET_CUSTOMER_DETAILS_EDITING',
  SET_ORDERS_COUNT: 'SET_ORDERS_COUNT',
  SET_ORDERS_LOADING: 'SET_ORDERS_LOADING',
  SET_ORDERS_ERROR: 'SET_ORDERS_ERROR',
  CLEAR_CUSTOMER_SIDEBAR: 'CLEAR_CUSTOMER_SIDEBAR',
  SET_LEAD_SCORE: 'SET_LEAD_SCORE',
  SET_LEAD_SCORE_LOADING: 'SET_LEAD_SCORE_LOADING',
  SET_LEAD_SCORE_ERROR: 'SET_LEAD_SCORE_ERROR',
  SET_FIELD_CAPTURES: 'SET_FIELD_CAPTURES',
  SET_FIELD_CAPTURES_LOADING: 'SET_FIELD_CAPTURES_LOADING',
  SET_FIELD_CAPTURES_ERROR: 'SET_FIELD_CAPTURES_ERROR',
  ADD_FIELD_CAPTURE: 'ADD_FIELD_CAPTURE'
};
